import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./styles/QuestionBox.css";
import { ReactComponent as QuestionIcon } from "../assets/question-icon.svg";
import { ReactComponent as ArrowDownIcon } from "../assets/arrow-down.svg";

const QuestionBox = ({ questionContent }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.div
      onClick={() => setIsOpen(!isOpen)}
      initial={false}
      animate={{ height: isOpen ? "auto" : "25px" }}
      transition={{ duration: isOpen ? 0.3 : 0.4 }}
      className="question-box"
    >
      <div className="question-content">
        <QuestionIcon style={{ marginRight: "10px" }} />
        {questionContent.question}
        <ArrowDownIcon
          style={{
            marginLeft: "auto",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      <AnimatePresence>
        {isOpen && (
          <div>
            <div
              className="line"
              style={{
                marginTop: "10px",
                marginBottom: "10px",
                width: "100%",
                height: "1px",
                backgroundColor: "var(--color-primary)",
              }}
            />
            <motion.p
              key="answer"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, transition: { duration: 0.4 } }}
              transition={{ duration: 0.1 }}
              className="answer-content"
              style={{ marginTop: "10px", color: "#555", marginBottom: "0px" }}
            >
              {questionContent.answer}
            </motion.p>
          </div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default QuestionBox;
